import "./CheckoutFooter.scss";

const CheckoutFooter = () => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-footer">
                        <ul>
                            <a
                                className="footerhlinlk"
                                href="http://www.xsel.app/terms-of-service/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Terms
                            </a>
                            <a
                                className="footerhlinlk"
                                href="http://www.xsel.app/privacy-policy/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Privacy
                            </a>
                            <a
                                className="footerhlinlk"
                                href="http://www.xsel.app/cookie-policy/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                Cookies
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CheckoutFooter;